module.exports = __webpack_public_path__ + "img/close-mini.364764f1.svg";